import { FONT_FAMILY } from 'styles/typography'
const themeStyles = colors => {
  const styles = {
    container: {
      fontFamily: FONT_FAMILY,
      backgroundColor: colors.lightSmoke,
      marginBottom: 20,
      padding: '8px 20px',
      fontSize: 12,
      lineHeight: '18px',
      border: `1px solid ${colors.silverGray}`,
      color: colors.black
    }
  }
  return styles
}

export default themeStyles

